import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import CreateClientTestimonial from "./CreateClientTestimonial";
import EditClientTestimonial from "./EditClientTestimonial";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  deleteClientTestimonial,
  getAllClientTestimonial,
} from "../../api/ClientTestimonial";
import "../../vendor/css/viewclienttestimonial.css";

const ViewClientTestimonial = () => {
  const [clientTestimonialList, setClientTestimonialList] = useState([]);
  const [selectedClientTestimonial, setSelectedClientTestimonial] = useState(
    {}
  );
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const testimonialsPerPage = 10;

  useEffect(() => {
    const getClientTestimonialList = async () => {
      try {
        const response = await getAllClientTestimonial();
        const testimonials = Array.isArray(response)
          ? response
          : response?.clientTestimonials || [];
        setClientTestimonialList(testimonials);
      } catch (error) {
        console.error("Error fetching client testimonials:", error);
        Swal.fire("Error", "Failed to load client testimonials", "error");
      } finally {
        setLoading(false);
      }
    };
    getClientTestimonialList();
    const interval = setInterval(getClientTestimonialList, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, []);

  // create and edit model state defind here
  const [
    createClientTestimonialModelShow,
    setCreateClientTestimonialModelShow,
  ] = useState(false);
  const handleCreateModalClose = () =>
    setCreateClientTestimonialModelShow(false);
  const handleCreateModalShow = () => setCreateClientTestimonialModelShow(true);
  const [editClientTestimonialModelShow, setEditClientTestimonialModelShow] =
    useState(false);
  const handleEditModalClose = () => setEditClientTestimonialModelShow(false);
  const handleEditModalShow = () => setEditClientTestimonialModelShow(true);

  // Filter testimonials based on search term
  const filteredTestimonials = (clientTestimonialList || []).filter(
    (testimonial) =>
      testimonial.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastTestimonial = currentPage * testimonialsPerPage;
  const indexOfFirstTestimonial = indexOfLastTestimonial - testimonialsPerPage;
  const currentTestimonials = filteredTestimonials.slice(
    indexOfFirstTestimonial,
    indexOfLastTestimonial
  );
  const totalPages = Math.ceil(
    filteredTestimonials.length / testimonialsPerPage
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDeleteClientTestimonial = (clientTestimonialToDelete) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteClientTestimonial(clientTestimonialToDelete)
          .then((res) => {
            if (res.status === 200) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              setClientTestimonialList((prev) =>
                prev.filter(
                  (item) => item._id !== clientTestimonialToDelete._id
                )
              );
            }
          })
          .catch((err) => {
            console.error("Delete failed:", err);
            Swal.fire("Error", "Failed to delete testimonial", "error");
          });
      }
    });
  };

  if (loading) {
    return (
      <div className="view-testimonials">
        <div className="testimonials-header">
          <h1>Client Testimonials Management</h1>
          <p>Manage and view all client testimonials</p>
        </div>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading testimonials...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="view-testimonials">
      <div className="testimonials-header">
        <h1 style={{ fontFamily: "serif" }}>Client Testimonials Management</h1>
        <p style={{ fontFamily: "serif" }}>
          Manage and view all client testimonials
        </p>
      </div>

      <div className="testimonials-stats">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bx bx-star"></i>
          </div>
          <div className="stat-content">
            <h3>{clientTestimonialList.length}</h3>
            <p>Total Testimonials</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bx bx-search"></i>
          </div>
          <div className="stat-content">
            <h3>{filteredTestimonials.length}</h3>
            <p>Filtered Results</p>
          </div>
        </div>
      </div>

      <div className="testimonials-controls">
        <div className="search-container">
          <i className="bx bx-search search-icon"></i>
          <input
            type="text"
            placeholder="Search by client name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        <button
          className="btn btn-primary add-testimonial-btn"
          onClick={handleCreateModalShow}
        >
          <i className="bx bx-plus"></i>
          Add Testimonial
        </button>
      </div>

      <div className="testimonials-grid">
        {currentTestimonials.length > 0 ? (
          currentTestimonials.map((testimonial, index) => (
            <div key={testimonial._id || index} className="testimonial-card">
              <div className="testimonial-content">
                <div className="client-profile">
                  <div className="client-avatar">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      onError={(e) => {
                        e.target.src = "https://via.placeholder.com/60?text=User";
                      }}
                    />
                  </div>
                  <div className="client-info">
                    <h3>{testimonial.name}</h3>
                    <div className="rating-stars">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className={`bx ${
                            i < testimonial.rating ? "bxs-star" : "bx-star"
                          }`}
                        ></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="testimonial-text">{testimonial.message}</p>
              </div>
              <div className="testimonial-actions">
                <button
                  className="edit-btn"
                  onClick={() => {
                    setSelectedClientTestimonial(testimonial);
                    handleEditModalShow();
                  }}
                  title="Edit Testimonial"
                >
                  <i className="bx bx-edit"></i>
                  Edit
                </button>
                <button
                  className="delete-btn"
                  onClick={() => handleDeleteClientTestimonial(testimonial)}
                  title="Delete Testimonial"
                >
                  <i className="bx bx-trash"></i>
                  Delete
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">
            <div className="no-data-content">
              <i className="bx bx-star-x"></i>
              <p>No testimonials found</p>
              <small>Try adjusting your search criteria</small>
            </div>
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            <i className="bx bx-chevron-left"></i>
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => paginate(i + 1)}
              className={`pagination-btn ${
                currentPage === i + 1 ? "active" : ""
              }`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            <i className="bx bx-chevron-right"></i>
          </button>
        </div>
      )}

      {/* Create Testimonial Modal */}
      <Modal
        show={createClientTestimonialModelShow}
        onHide={handleCreateModalClose}
        className="testimonial-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Testimonial</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateClientTestimonial
            onSuccess={(res) => {
              console.log(res);
              setCreateClientTestimonialModelShow(false);
              setClientTestimonialList(res?.clientTestimonials || res);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCreateModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Testimonial Modal */}
      <Modal
        show={editClientTestimonialModelShow}
        onHide={handleEditModalClose}
        className="testimonial-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Testimonial</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditClientTestimonial
            clientTestimonial={selectedClientTestimonial}
            onSuccess={(res) => {
              setEditClientTestimonialModelShow(false);
              setClientTestimonialList(res?.clientTestimonials || res);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleEditModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ViewClientTestimonial;
